<template>
	<b-modal ref="modal" hide-footer>
        <template v-slot:modal-title>
            <template v-if="ajouter">
                {{ $t("invoice.devis.ajouter_document") }}
            </template>

            <template v-else>
                {{ $t("invoice.devis.rename_document") }}
            </template>
        </template>
        <div>

      		<label>{{ $t('monte.type_document_contract.label') }} :</label>
	        <div class="form-group">
				<e-select
					v-model="document_type"
					:options="document_types"
					:searchable="true"
				>
	                <template slot="option" slot-scope="{ option }">{{ $t('monte.type_document_contract.'+option) }}</template>
	                <template slot="singleLabel" slot-scope="{ option }">{{ $t('monte.type_document_contract.'+option) }}</template>
	                <template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
	        </div>

        	<label>{{ $t('invoice.devis.nom_document') }}* :</label>
	        <div class="form-group">
	            <input type="text" class="form-control" v-model="document_label" :placeholder="$t('invoice.devis.nom_document')" required>
	        </div>


	        <template v-if="ajouter">
				<label>{{ $t('invoice.devis.fichier') }}* :</label>
		        <b-form-file
		            v-model="document_file"
		            :accept="type_file_accepted"
		            :state="Boolean(document_file)"
		            :placeholder="$t('invoice.devis.choisir_document')"
		            :drop-placeholder="$t('fichier.drop_files')+'...'"
		        ></b-form-file>

		        <div v-show="document_file" class="mt-3">
		            {{ $t('fichier.selected_files') }} :
		            <span> {{ document_file ? document_file.name : '' }}</span>
		        </div>
		    </template>

			<div class="col-12 mt-2 text-center">
				<b-button variant="primary" rounded-pill @click="saveDocument"><font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /> {{ $t('global.enregistrer') }}</b-button>
			</div>
        </div>
    </b-modal>
</template>

<script type="text/javascript">
    import Contract from "@/mixins/Contract.js"

	export default {
		name: 'ModalContractDocument',
		mixins: [Contract],
		props: ['contract_id'],
		data () {
			return {
				document_id: null,
				document_label: '',
				document_file: null,
				type_file_accepted: "image/jpeg, image/jpg, image/png, application/pdf",
				processing: false,
				ajouter: true,
				document_type: null,
				document_types: ['dn', 'as', 'sign', 'te', 'other']
			}
		},

		watch: {
			document_type(newType) {
				this.autofillLabelFromType(newType)
			}
		},

		methods: {
			openModal(doc = null) {
                this.$refs.modal.show()
                if(doc) {
                	this.document_id = doc.contractdocument_id
                	this.document_label = doc.contractdocument_label
                	this.document_file = new File([], doc.contractdocument_filename)
                	this.document_type = 'other'
                	if(doc.contractdocument_dn) this.document_type = 'dn'
                	if(doc.contractdocument_as) this.document_type = 'as'
                	if(doc.contractdocument_sign) this.document_type = 'sign'
                	if(doc.contractdocument_te) this.document_type = 'te'
                	this.ajouter = false
                }
                else {
                	this.document_id = null
                	this.document_label = ''
                	this.document_file = null
                	this.document_type = null
                	this.ajouter = true
                }
			},

			closeModal() {
                this.$refs.modal.hide()
				this.document_id = null
				this.document_label = ''
				this.document_file = null
				this.ajouter = true
			},

			/**
			 * Pré-remplit le nom du document avec le libellé du type sélectionné
			 * lorsque le champ nom est vide. Limité au mode ajout pour ne pas
			 * écraser un nom existant en édition.
			 */
			autofillLabelFromType(type) {
				if (!this.ajouter) return
				if (!type) return
				if (this.document_label && this.document_label.trim() !== '') return
				this.document_label = this.$t('monte.type_document_contract.' + type)
			},

			async saveDocument() {
				if(!this.document_type || !this.document_label) {
					this.failureToast("formulaire.erreur_champs_non_remplis")
					return
				}
				this.processing = true
				if(this.ajouter) {
					const doc = await this.addContractDocument(this.contract_id, {document_label: this.document_label, document_type: this.document_type})
					this.document_id = doc.contractdocument_id
					await this.uploadDocumentContractFile(this.contract_id, this.document_id, this.document_file)
				}
				else {
					await this.editContractDocument(this.contract_id, this.document_id, {document_label: this.document_label, document_type: this.document_type})
				}
				
				this.processing = false
				this.$emit('submit')
				this.closeModal()
			},
		},
	}

</script>